import React, { useEffect, useState } from "react";
import Navbar from "../../component/Navbar/Navbar";
import IconMarquee from "../../component/marquee/Marquee";
import HowItWorkVideo from "./HowItWorks";
import PricingSection from "../Pricing/PricingSection";
import UseCases from "./UseCases";
import Footer from "../../component/Footer/Footer";
import VoiceTypeOrTranslateSection from "./VoiceTypeOrTranslateSection";
import PersonalDictionarySection from "./PersonalDictionarySection";
import AIPoweredSection from "./AI-PoweredSection";
import PromptsSection from "./PromptsSection";
import { DemoButton } from "../../component/DemoButton/DemoButton";
import { useInView } from "react-intersection-observer";
import DownloadButton from "../../component/DownlButton/DownloadButton";
// import { lazy } from "react";
// import { Suspense } from "react";
// import Loader from "../../component/Loader/Loader";
// const IconMarquee = lazy(() => import("../../component/marquee/Marquee"));

// const VoiceTypeOrTranslateSection = lazy(() =>
//   import("./VoiceTypeOrTranslateSection")
// );
// const PersonalDictionarySection = lazy(() =>
//   import("./PersonalDictionarySection")
// );

const Home = () => {
  const { ref: buttonRef, inView: buttonView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });
  const isMobile = useBreakpoint();

  const { ref: HIWHeadingRef, inView: HIWHeadingView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });
  const { ref: PriceHeadingRef, inView: PriceHeadingView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });
  const { ref: PriceSubRef, inView: PriceSubView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });
  const { ref: PriceCardRef, inView: PriceCardView } = useInView({
    triggerOnce: true,
    threshold: isMobile ? 0.1 : 0.5,
  });
  return (
    <>
      <div className="bg-white  md:p-4 p-3 flex flex-col xl:gap-20 lg:gap-16 gap-12 max-w-screen-2xl mx-auto  leading-tight">
        {/* <Suspense fallback={<Loader />}>
        </Suspense> */}

        <Navbar />
        <div className="relative  overflow-hidden rounded-2xl mt-6 md:mt-0">
          <div className="absolute  top-0 left-0 w-full h-full hidden md:flex flex-col z-0">
            <div className="relative flex-[1] bg-gradient-to-t from-[#3AB1F650]  to-[#D8EFFD] rounded-2xl">
              <svg
                className="absolute top-0 left-0 w-full h-full  rounded-2xl z-[4]"
                viewBox="0 0 1000 1350"
                preserveAspectRatio="none"
              >
                <path
                  id="orbitPath"
                  d="
              M40,0 
              H960 
              A40,40 0 0 1 1000,40 
              V1310 
              A40,40 0 0 1 960,1350 
              H40 
              A40,40 0 0 1 0,1310 
              V40 
              A40,40 0 0 1 40,0 
              Z"
                  fill="none"
                  stroke="transparent"
                />

                {/* Orbiting Glow Circle */}
                <circle r="300" fill="url(#glow)" filter="url(#blur)">
                  <animateMotion
                    repeatCount="indefinite"
                    dur="20s"
                    rotate="auto"
                  >
                    <mpath href="#orbitPath" />
                  </animateMotion>
                </circle>

                <circle r="300" fill="url(#glow)" filter="url(#blur)">
                  <animateMotion
                    repeatCount="indefinite"
                    dur="20s"
                    rotate="auto"
                    keyPoints="1;0"
                    keyTimes="0;1"
                  >
                    <mpath href="#orbitPath" />
                  </animateMotion>
                </circle>

                {/* Gradient Glow */}
                <defs>
                  <radialGradient id="glow" cx="50%" cy="50%" r="50%">
                    <stop offset="0%" stopColor="#3AB1F6" stopOpacity=".9" />
                    <stop offset="100%" stopColor="#3AB1F6" stopOpacity="0" />
                  </radialGradient>
                </defs>
                <filter
                  id="blur"
                  x="-100%"
                  y="-100%"
                  width="300%"
                  height="300%"
                >
                  <feGaussianBlur in="SourceGraphic" stdDeviation="20" />
                </filter>
              </svg>
            </div>
          </div>
          {/* hero section */}
          <div className="flex md:flex-row flex-col items-center md:gap-2 gap-10  md:pt-36 pt-20 md:pb-20 lg:px-10 md:px-6 p-2 z-10 relative">
            <div className=" flex-1 flex flex-col md:items-start items-center xl:gap-5 lg:gap-4 gap-3">
              <div className=" xl:text-[3.125rem] lg:text-[2.8rem] md:text-[2.4rem] text-[2.625rem] md:text-left text-center  leading-tight  font-jakarta font-bold">
                Stop Typing.
                <ShinyText
                  text="Start Talking."
                  speed={5}
                  className="custom-class text-wrap"
                />
              </div>
              <div className=" xl:text-[1.438rem] lg:text-[1.2rem] md:text-[1.15rem] text-[1.313rem] leading-snug text-[#00000099] font-inter md:text-left text-center ">
                Your words, instantly typed anywhere.{" "}
                <br className="sm:flex hidden" />
                With fast, accurate voice dictation powered by AI: Works
                <br className=" xl:block hidden" /> with all your apps.
              </div>

              <div className="flex sm:flex-row flex-col items-center md:items-start gap-3">
                <DemoButton text="Get Started" />
                <DownloadButton ref={buttonRef} view={buttonView} />
              </div>


              {/* <DemoButton text="Try it now!" />
              <DownloadButton ref={buttonRef} view={buttonView} /> */}
            </div>
            <div className=" flex-1 flex justify-center items-center">
              <video
                className=" lg:w-[85%] md:w-[90%] w-full xl:rounded-3xl rounded-2xl "
                src="https://pub-25f4599302a64a3dab9e149b2b5f9a0f.r2.dev/videos/HERO SECTION.mp4"
                autoPlay
                loop
                muted
                playsInline
                webkit-playsinline="true"
                preload="metadata"
              />
            </div>
          </div>
        </div>
        <IconMarquee text="Integrated Apps. Less Chaos, More Efficiency." />
        {/* Voice Type Or Translate section */}
        <VoiceTypeOrTranslateSection />
        {/* Personal Dictionary section */}
        <PersonalDictionarySection />

        {/* AI-Powered section */}
        <AIPoweredSection />
        {/* Prompts section */}
        <PromptsSection />
        {/* How It Works */}
        <div className="flex flex-col  md:gap-14 gap-10 xl:pt-10 lg:pt-8 md:pt-6 xl:pb-10 lg:pb-8 md:pb-6 lg:px-10 md:px-6 z-[5] bg-white ">
          <div className="xl:gap-5 lg:gap-4 gap-3 ">
            <div
              ref={HIWHeadingRef}
              className={`${HIWHeadingView
                ? `animate-slideUp z-[3] anim-preserve`
                : "opacity-0 z-0"
                } xl:text-[3.125rem] lg:text-[2.8rem] md:text-[2.4rem]  text-[2.625rem]   leading-tight text-center mx-auto  font-jakarta font-bold`}
            >
              How It
              <ShinyText
                text=" Works"
                speed={5}
                className="custom-class text-wrap"
              />
            </div>
            <div className="text-[#00000099] z-[4] relative bg-white xl:text-[1.438rem] lg:text-[1.2rem] md:text-[1.15rem] text-[1.313rem] font-inter text-center">
              Setting up Zero Typing is simple and quick.
            </div>
          </div>
          <HowItWorkVideo />
        </div>
        {/* pricing section*/}
        <div className=" flex flex-col gap-10 xl:pt-10 lg:pt-8 md:pt-6 xl:pb-10 lg:pb-8 md:pb-6 lg:px-10 md:px-6 z-[5] bg-white">
          <div className="flex flex-col xl:gap-6 lg:gap-5 gap-4 mb-6">
            <div
              ref={PriceHeadingRef}
              className={` ${PriceHeadingView
                ? `animate-slideUp z-[3] anim-preserve`
                : "opacity-0 z-0"
                } xl:text-[3.125rem] lg:text-[2.8rem] md:text-[2.4rem] text-[2.625rem] tracking-tighter leading-tight font-bold flex flex-col text-center font-jakarta `}
            >
              <span>Type with Your Voice.</span>
              <ShinyText
                text="Anywhere"
                speed={5}
                className="custom-class text-wrap"
              />
            </div>
            <div className=" z-[4] relative bg-white text-center xl:text-[1.438rem] lg:text-[1.2rem] md:text-[1.15rem] text-[1.313rem] font-inter text-[#00000099]">
              <span>
                Save hours every week by ditching the keyboard. Dictate,
                <br className="hidden md:flex" /> refine, and insert text in any
                app with ZeroTyping.
              </span>
            </div>
            <div
              ref={PriceSubRef}
              className={`${PriceSubView
                ? `animate-slideUp anim-preserve z-[3]`
                : "opacity-0 z-0"
                } w-full text-center text-wrap text-[#00000099] xl:text-[2.1875rem] lg:text-[2.05rem] md:text-[1.9rem] text-[1.65rem] font-justMe`}
            >
              Choose the plan that’s right for you.
            </div>
          </div>
          <div
            ref={PriceCardRef}
            className={`${PriceCardView
              ? `animate-slideUp anim-preserve z-[3]`
              : "opacity-0 z-0"
              } `}
          >
            <PricingSection />
          </div>
        </div>
        <div className=" flex flex-col overflow-hidden md:pt-10 md:pb-10 z-[5] bg-white">
          <UseCases />
        </div>
      </div>
      <Footer />
      {/* <div className="fixed z-20 md:bottom-6 md:right-6 bottom-4 right-4">
        <SideCTA />
      </div> */}
    </>
  );
};

export const ShinyText = ({ text, speed = 5, className = "" }) => {
  const animationDuration = `${speed}s`;

  return (
    <span
      className={`bg-clip-text text-transparent text-wrap animate-shine
       ${className}`}
      style={{
        backgroundImage:
          "linear-gradient(45deg, #3AB1F6 20%, #407BFF 60%,  #3AB1F6 80%)",
        backgroundSize: "200% 100%",
        WebkitBackgroundClip: "text",
        animationDuration: animationDuration,
      }}
    >
      {text}
    </span>
  );
};

export const useBreakpoint = (breakpoint = 768) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < breakpoint);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [breakpoint]);

  return isMobile;
};

export default Home;
